import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import SelectWithSearch from "@/features/shared/components/SelectWithSearch/SelectWithSearch";
import usePriorities from "@/features/priority/hooks/usePriorities";
const PrioritySelector = ({ onSelect, initialValue }) => {
    const { priorities } = usePriorities();
    const [selectedPriority, setSelectedPriority] = useState(initialValue ? { value: initialValue.id ?? 0, label: initialValue.label ?? "" } : { value: 0, label: "" });
    const priorityOptions = priorities.map((prio) => ({
        value: prio.id ?? 0,
        label: prio.label ?? "",
    }));
    const handlePrioritySelect = (option) => {
        const selected = priorities.find((p) => p.id === option.value);
        if (selected) {
            const newSelection = { value: selected.id ?? 0, label: selected.label ?? "" };
            setSelectedPriority(newSelection);
            onSelect(selected);
        }
    };
    return (_jsx(SelectWithSearch, { label: "Priorit\u00E9", options: priorityOptions, selectedItem: selectedPriority, onSelect: handlePrioritySelect }));
};
export default PrioritySelector;
